import { isEmpty } from "lodash";
import UserItem from "../UserItem";
import styles from "./styles.module.scss";
import React from "react";
import { StudentProgramRegistrationModel } from "app/models/scheduling/StudentProgramRegistrationModel";

type UserItemsProps = {
  userList: StudentProgramRegistrationModel[];
  onClose?: (registration: StudentProgramRegistrationModel) => void;
  onExpired?: (registrationId: number) => void;
  showEmail?: boolean;
  separatorStyle?: string | null;
  allowRemove?: boolean;
  showPaymentMethod?: boolean;
  forcePending?: boolean;
  currentUserId?: string;
  waitlisted?: boolean;
  useEllipsisMenu?: boolean;
  onManagePayment?: (registration: StudentProgramRegistrationModel) => void;
  onMarkAsPaid?: (registration: StudentProgramRegistrationModel) => void;
  onMarkAsUnpaid?: (registration: StudentProgramRegistrationModel) => void;
  onMove?: (registration: StudentProgramRegistrationModel) => void;
};

export default function UserItems(props: UserItemsProps) {
  const {
    userList,
    onClose,
    onExpired,
    showEmail = true,
    separatorStyle = null,
    forcePending = false,
    currentUserId,
    waitlisted = false,
    showPaymentMethod,
    allowRemove,
    useEllipsisMenu = false,
    onManagePayment,
    onMarkAsPaid,
    onMarkAsUnpaid,
    onMove,
  } = props;

  if (isEmpty(userList)) {
    return null;
  }

  return (
    <>
      {userList.map((item, index) => {
        const isCurrentUser = currentUserId && item.studentProfile.id === currentUserId;
        return (
          <div key={item.studentProfile.id}>
            <UserItem
              registration={item}
              showEmail={showEmail}
              closeStyle={styles.close_style}
              height={48}
              width={48}
              itemStyle={styles.item_style}
              onClose={onClose}
              onExpired={onExpired}
              showPaymentMethod={showPaymentMethod}
              allowRemove={allowRemove && item?.canRemove}
              forcePending={forcePending}
              isCurrentUser={isCurrentUser}
              waitlisted={waitlisted}
              useEllipsisMenu={useEllipsisMenu}
              onManagePayment={onManagePayment}
              onMarkAsPaid={onMarkAsPaid}
              onMarkAsUnpaid={onMarkAsUnpaid}
              onMove={onMove}
            />
            {index + 1 < userList.length && <div className={separatorStyle || styles.line_separator} />}
          </div>
        );
      })}
    </>
  );
}
